<template>
    <b-container fluid class="animated fadeIn">
        <h1>Ajuizamento - Exibir Dívidas Disponíveis</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i
                                    class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna :fields="fields" :showColunms="showColunms"
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect v-model="filtrarPor" :show-labels="false" :options="opcoesFiltro"
                                                :multiple="true" :close-on-select="false" :clear-on-select="false"
                                                :preserve-search="true" placeholder="Selecione" track-by="id"
                                                label="filtro">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
                                            <b-form-input v-model="filtro.numeroDivida" type="number" id="numeroDivida"
                                                maxlength="8" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                            <the-mask id="cpfCnpj" class="form-control" v-model="filtro.cpfCnpj"
                                                :mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
                                            <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte"
                                                maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
                                            <b-form-input v-model="filtro.cadimcs" type="text" id="cadicms"
                                                maxlength="20" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Comarca:" label-for="comarca" class="text-label">
                                            <multiselect v-model="filtro.comarca" :show-labels="false"
                                                :options="dados.comarcas" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="codComarca">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Origem:" label-for="origem" class="text-label">
                                            <multiselect v-model="filtro.origem" :show-labels="false"
                                                :options="dados.origens" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="id">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                            <multiselect v-model="filtro.credito" :show-labels="false"
                                                :options="dados.creditos" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="id">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 8).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Início):" label-for="dtInscricaoInicio"
                                            class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Fim)" label-for="dtInscricaoFim"
                                            class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 10).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Situação CADICMS:" label-for="situacaoCadicms"
                                            class="text-label">
                                            <multiselect v-model="filtro.situacaoCadicms" :show-labels="false"
                                                :options="dados.situacoesCadicms" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="id">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 9).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-checkbox v-model="filtro.origemAgrupamentoGIA">Agrupar GIA</b-form-checkbox>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 11).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <b-form-group label="ICMS - Auto de Infração:" label-for="autoInfracao"
                                            class="text-label">
                                            <b-form-checkbox v-model="filtro.exibirCdaValorMultaMaior"
                                                @input="selectAutoInfracao(0)">Exibir CDA´s com valor multa maior que valor
                                                principal.</b-form-checkbox>
                                            <b-form-checkbox v-model="filtro.ocultarCdaValorMultaMaior"
                                                @input="selectAutoInfracao(1)">Retirar CDA´s com valor multa maior que valor
                                                principal.</b-form-checkbox>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button variant="primary fonte-branca" @click="filtrar">
                                                <i class="fa fa-search"></i> Pesquisar
                                            </b-button>
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                    <b-row class="d-flex justify-content-between mt-2">
                        <b-col>
                            <b-row class="ml-3">
                                <div style="color: #0000FF; margin-bottom: -8px;">
                                    <i class="fa fa-square"></i> ICMS - Auto de Infração (Valor Multa Maior que Valor
                                    Principal)
                                </div>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="d-flex justify-content-between mt-2">
                        <CompAvisos />
                        <b-col align-self="end">
                            <div class="d-flex justify-content-between mb-3" style="float:right">
                                <div>
                                    <b-button class="mx-1 " variant="primary" @click.prevent="disponibilizarProtesto"
                                        :disabled="!selecteds.length"><i class="fa fa-pencil-square-o"></i> Disponibilizar
                                        para Protesto</b-button>
                                    <b-button class="mx-1" variant="primary" @click.prevent="montarProcesso"
                                        :disabled="!selecteds.length"><i class="fa fa-file-text-o"></i> Montar
                                        Processo</b-button>
                                    <b-button class="mx-1" variant="primary" @click.prevent="showModalJustificativa"
                                        :disabled="selecteds.length < 1 || !dataCorrenteAtual"><i class="fa fa-warning"></i>
                                        Encaminhar para Exceções</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas Disponibilizadas - Valor Total: <strong>R$ {{
                                                configTable.totalGeral | currency }}</strong> &nbsp; <i
                                                    class="fa fa-info-circle" aria-hidden="true"
                                                    :title="'Previsão de Processos - Atualizado em ' + configTable.dataAtualizacaoPrevisao"
                                                    :alt="'Previsão de Processos - Atualizado em ' + configTable.dataAtualizacaoPrevisao"></i>
                                                Processos: <strong>{{ configTable.quantidadePrevisao }}</strong> &nbsp;
                                                CDA's: <strong>{{ configTable.quantidadeGeral }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaCdaDisponivel :resultado="resultado" :fields="fields"
                                        :configTable="configTable" :selecteds="selecteds"
                                        :processosSelecteds="processosSelecteds" @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col align-self="end">
                                            <label style="float:right">Processos: {{ processosSelecteds.length }} &nbsp;
                                                Quantidade selecionada: {{ selecteds.length }} &nbsp; Valor Total:
                                                <strong>R$ {{ totalSelectedValue | currency }}</strong></label>
                                        </b-col>
                                    </b-row>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1 " variant="primary" :disabled="loadCSV"
                                    @click.prevent="exportCSV()"><i class="fa fa-cloud-download" v-if="!loadCSV"></i>
                                    <b-spinner small v-if="loadCSV"></b-spinner>
                                    Exportar CSV
                                </b-button>
                                <b-button class="mx-1" variant="secondary" @click="voltar()"><i class="fa fa-reply"></i>
                                    Voltar</b-button>
                                <b-button class="mx-1 " variant="primary" @click="abrirMontagemProcessos()">
                                    Montagem de Processos
                                    <i class="fa fa-arrow-right"></i>
                                </b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
            <b-modal ref="modalJustificativa" size="lg" title="Justificativa" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <b-form-textarea id="justificativa" v-model="justificativa"
                            placeholder="Informe aqui a justificativa.." rows="3" max-rows="6">
                        </b-form-textarea>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div style="width:100%; text-align:center">
                        <b-button size="md" variant="success" @click="encaminharExecoes()" class="float-left">
                            Confirmar
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompAvisos from './components/CompAvisos'
import CompPaginacao from './components/CompPaginacao'
import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
import CompTabelaCdaDisponivel from './components/CompTabelaCdaDisponivel'

export default {
    name: 'ExibirDividaDisponivel',
    components: {
        CompAvisos,
        CompPaginacao,
        CompExibirOcultarColuna,
        CompTabelaCdaDisponivel,
    },
    data() {
        return {
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Número da Dívida'
                },
                {
                    id: 2,
                    filtro: 'CPF/CNPJ'
                },
                {
                    id: 3,
                    filtro: 'Contribuinte'
                },
                {
                    id: 4,
                    filtro: 'CAD ICMS'
                },
                {
                    id: 5,
                    filtro: 'Comarca'
                },
                {
                    id: 6,
                    filtro: 'Origem'
                },
                {
                    id: 7,
                    filtro: 'Tipo de Crédito'
                },
                {
                    id: 8,
                    filtro: 'Data de Inscrição'
                },
                {
                    id: 9,
                    filtro: 'Agrupar GIA'
                },
                {
                    id: 10,
                    filtro: 'Situação CADICMS'
                },
                {
                    id: 11,
                    filtro: 'ICMS - Auto de Infração'
                }
            ],
            ano: null,
            mes: null,
            dataCorrenteAtual: false,
            filtro: {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                origem: null,
                origemAgrupamentoGIA: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                situacaoCadicms: null,
                exibirCdaValorMultaMaior: null,
                ocultarCdaValorMultaMaior: null,
            },
            dados: {
                comarcas: [],
                origens: [],
                creditos: [],
                situacoesCadicms: []
            },
            configTable: {
                perPage: 100,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0.00,
                quantidadeGeral: 0,
                quantidadePrevisao: 0,
                dataAtualizacaoPrevisao: 'Carregando...'
            },
            showColunms: [],
            selecteds: [],
            processosSelecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            loadCSV: false,
            filtrarPor: [],
            justificativa: null
        }
    },
    watch: {
        perPage() {
            this.configTable.checkedAll = false
            this.processosSelecteds = []
            this.selecteds = []
            this.configTable.currentPage = 1
            this.consultarDividas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
        totalSelectedValue() {
            let total = 0.00
            this.selecteds.forEach(divida => {
                total = total + divida.valor
            })
            return total
        },
        totalResultValue() {
            let total = 0.00
            this.resultado.forEach(result => {
                result.dividas.forEach(divida => {
                    total = total + divida.valor
                })
            })
            return total
        },
    },
    methods: {

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                origem: null,
                origemAgrupamentoGIA: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
            }
            this.filtrarPor = []
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.selecteds = []
            this.processosSelecteds = []
            this.consultarDividas()
        },

        /**
         * Enviar CDA's para protesto
         */
        disponibilizarProtesto() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/disponibilizarProtesto`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Dívidas disponibilizadas para protesto com sucesso!'] });
                    this.selecteds = []
                })
                .finally(() => {
                    this.loadingExit()
                    this.consultarDividas()
                })
        },

        /**
         * Enviar cdas para montagem de processos
         */
        montarProcesso() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/montarProcesso`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Montagem dos processos em processamento. O andamento poderá ser visualizado na tela Montagem de Processos.'] });
                    this.selecteds = []
                    this.processosSelecteds = []
                })
                .finally(() => {
                    this.loadingExit()
                    this.consultarDividas()
                })
        },

        showModalJustificativa() {
            this.$refs['modalJustificativa'].show();
        },

        hideModalJustificativa() {
            this.$refs['modalJustificativa'].hide();
        },

        encaminharExecoes() {
            if (!this.justificativa) {
                return;
            }

            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).access_token;

            this.hideModalJustificativa();
            this.loadingEnter();

            axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/encaminharExecoes?justificativa=` + this.justificativa, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Processos encaminhados para exceções com sucesso.'] });
                this.selecteds = []
                this.processosSelecteds = []
            })
                .finally(() => {
                    this.loadingExit();
                    this.consultarDividas();
                })
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo: ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if (i == 1 || i == 2 || i == 5 || i == 6)
                return 'text-center justify-content-center'
            if (i == 7)
                return 'text-right justify-content-center'
            return ''
        },

        /**
         * Exporta as CDA's em CVS
         */
        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadCSV = true
            if (this.selecteds.length) {
                axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/exportarCsv`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            } else {
                const filtro = this.obterFiltro()

                axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/exportarCsv/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            }
        },

        /**
         * Efetua o download do CSV a partir do response
         */
        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CDADisponivelAjuizamento.csv');
            document.body.appendChild(link);
            link.click();
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        abrirMontagemProcessos() {
            this.$router.push('/ajuizamento/exibir-processos-montados');
        },

        /**
         * Consultar divídas
         */
        async consultarDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if (this.configTable.perPage == 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.consultarValorTotal()
            this.consultarPrevisoesProcessos()
            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    this.resultado = response.data.resultado
                    if (this.configTable.perPage != 'Todos') {
                        this.configTable.rows = response.data.rows
                    }

                    this.configTable.checkedAll = true
                    this.resultado.forEach(result => {
                        const dividas = result.dividas || []
                        dividas.forEach(divida => {
                            this.selecteds.forEach(selected => {
                                if (divida.id == selected.id) {
                                    const index = this.selecteds.indexOf(selected)
                                    this.selecteds.splice(index, 1)

                                    this.selecteds.push(divida)
                                    divida.checked = true
                                    result.checked = true
                                }
                            })
                            if (!this.selecteds.includes(divida)) {
                                this.configTable.checkedAll = false
                            }
                        })

                    })

                }).finally(() => {
                    this.loadingExit()
                })
        },

        /**
         * Obter filtro
         */
        obterFiltro() {
            return {

                numeroDivida: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.numeroDivida : null,
                cpfCnpj: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cpfCnpj : null,
                contribuinte: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.contribuinte : null,
                cadimcs: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.cadimcs : null,
                comarca: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.comarca : null,
                origem: (this.filtrarPor.filter(e => e.id == 6).length > 0) ? this.filtro.origem : null,
                credito: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? this.filtro.credito : null,
                dtInscricaoInicio: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? (this.filtro.dtInscricaoInicio ? this.filtro.dtInscricaoInicio.toString() : null) : null,
                dtInscricaoFim: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? (this.filtro.dtInscricaoFim ? this.filtro.dtInscricaoFim.toString() : null) : null,
                origemAgrupamentoGIA: (this.filtrarPor.filter(e => e.id == 9).length > 0) ? (this.filtro.origemAgrupamentoGIA ? true : false) : false,
                situacaoCadicms: (this.filtrarPor.filter(e => e.id == 10).length > 0) ? this.filtro.situacaoCadicms : null,
                exibirCdaValorMultaMaior: (this.filtrarPor.filter(e => e.id == 11).length > 0) ? (this.filtro.exibirCdaValorMultaMaior ? true : false) : false,
                ocultarCdaValorMultaMaior: (this.filtrarPor.filter(e => e.id == 11).length > 0) ? (this.filtro.ocultarCdaValorMultaMaior ? true : false) : false,
            }
        },

        /**
         * Consultar valor total das dividas e quantidade
         */
        async consultarValorTotal() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/consultar/valorTotal/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    this.configTable.totalGeral = response.data.valorTotal
                    this.configTable.quantidadeGeral = response.data.totalDividas
                })
        },

        /**
         * Consultar previsoes
         */
        async consultarPrevisoesProcessos() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            const filtro = this.obterFiltro();

            this.loadingEnter();
            axios.post(`${urlApi}/v1/cdaDisponivelAjuizamento/consultar/previsaoProcesso/${this.ano}/${this.mes}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    this.configTable.quantidadePrevisao = response.data.quantidadeTotalPrevisao;
                    this.configTable.dataAtualizacaoPrevisao = response.data.ultimaDataAtualizacaoPrevisa;
                })
        },

        /**
         * Listar comarcas
         */
        async listarComarcas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/comarca/listar`)
                .then(response => {
                    this.dados.comarcas = response.data
                })
        },

        /**
         * Listar os Tipos de Origem
         */
        async listarTipoOrigem() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaDisponivelAjuizamento/listarOrigem`)
                .then(response => {
                    this.dados.origens = response.data
                })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaDisponivelAjuizamento/listarTipoCredito`)
                .then(response => {
                    this.dados.creditos = response.data
                })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'cdaDisponivelAjuizamento'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            sortable: true,
                            sortDirection: "desc",
                            class: this.checkClassTable(i),
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        },

        selectAutoInfracao(ind) {
            if (ind == 0 && this.filtro.exibirCdaValorMultaMaior) {
                this.filtro.ocultarCdaValorMultaMaior = false;
            } else if (ind == 1 && this.filtro.ocultarCdaValorMultaMaior) {
                this.filtro.exibirCdaValorMultaMaior = false;
            }
        },

        /**
         * Listar Situação CADICMS
         */
        async listarSituacoesCadicms() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/cdaDisponivelAjuizamento/listarSituacaoCadicms`)
                .then(response => {
                    this.dados.situacoesCadicms = response.data
                })
        }
    },
    mounted() {
        const dataAtual = new Date(this.$store.getters.getDataMonitoramento)

        this.ano = dataAtual.getFullYear()
        this.mes = dataAtual.getMonth() + 1

        var dataAtualSistema = new Date();
        this.dataCorrenteAtual = this.ano == dataAtualSistema.getFullYear() &&
            this.mes == (dataAtualSistema.getMonth() + 1);

        this.$store.commit("setMessages", {});

        this.consultarDividas()
        this.obterConfiguracaoUsuario()
        this.listarComarcas()
        this.listarTipoOrigem()
        this.listarTipoCredito()
        this.listarSituacoesCadicms();
    },

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.fonte-branca {
    color: #FFF;
}

.fonte-branca:hover {
    color: #FFF;
}

.fonte-branca:active {
    color: #FFF !important;
}

.table-sub-item,
.table-sub-item>th,
.table-sub-item>td {
    background-color: rgb(237, 237, 238);
}
</style>
